import "react-app-polyfill/ie11";
import "react-app-polyfill/stable";

import React from "react";
import {render} from "react-dom";
import { defaultLang } from "./components/common/Constants";
import LangProvider from "./components/common/LangProvider";
import { I18nContext } from './containers/i18n';
import "./index.css";
import App from "./App";
import * as serviceWorker from "./serviceWorker";


render(
    <LangProvider>
        <I18nContext.Consumer>
            {({lang}) =>  <App lang={lang}/> }
        </I18nContext.Consumer>
      
    </LangProvider>,
    document.getElementById("root")
);

var isFirefox = navigator.userAgent.toLowerCase().indexOf("firefox") > -1;
if (!isFirefox) serviceWorker.unregister();
